"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldLoadXpPlanNames = exports.getCovidShouldUseDefaultStepOrder = exports.isCovidVaccineProvider = exports.getCovidPatientRegFormConfig = void 0;
const provider_1 = require("./constants/provider");
/**
 * Looks for the covid patient_reg_form config in the PMCDB config object
 * @param {Object} config The PMCDB config object from CS
 * @returns {Object} The covid vaccine specific patient_reg_form
 * @returns {undefined} if a covid reg form config isn't found
 */
const getCovidPatientRegFormConfig = (config) => {
    return config.covid && config.covid.patient_reg_form;
};
exports.getCovidPatientRegFormConfig = getCovidPatientRegFormConfig;
/**
 * Determines if a provider is a covid vaccine provider, based on entity_type
 * @param {Object} provider Provider oject
 * @returns {Boolean} Whether or not the provider is a covid vaccine provider
 */
const isCovidVaccineProvider = (provider) => {
    if (provider[provider_1.PROVIDER_TYPE]) {
        return provider[provider_1.PROVIDER_TYPE] === provider_1.COVID_VACCINE_PROVIDER_TYPE;
    }
    return false;
};
exports.isCovidVaccineProvider = isCovidVaccineProvider;
const getCovidShouldUseDefaultStepOrder = (config) => {
    return Boolean(config.covid && config.covid.use_default_step_order);
};
exports.getCovidShouldUseDefaultStepOrder = getCovidShouldUseDefaultStepOrder;
/**
 * Determines based on a given patient reg form config whether or not _xp_plan_names are required
 * @param {Object} regFormConfig Patient reg form configuration oject
 * @returns {Boolean} Whether or not the given reg form config requires _xp_plan_names
 */
const shouldLoadXpPlanNames = (regFormConfig) => {
    const { fields } = regFormConfig || {};
    return fields.some((field) => {
        return (field.path &&
            field.path.includes('plan_name') &&
            // forms-v2 fields without isVisible specified default to isVisible = true
            field.isVisible !== false);
    });
};
exports.shouldLoadXpPlanNames = shouldLoadXpPlanNames;
//# sourceMappingURL=covidVaccineUtils.js.map